// extracted by mini-css-extract-plugin
var _1 = "MAmiP";
var _2 = "nPbq1";
var _3 = "cph7R";
var _4 = "NXjY6";
var _5 = "UHNIk";
var _6 = "qPATG";
export { _1 as "body", _2 as "footer", _3 as "loading", _4 as "table", _5 as "title", _6 as "versionCell" }
